<template>
  <div class="check-list-person auto-list_col_centered">
    <p class="date">{{ getDate(response) }}</p>
  </div>
</template>

<script>
import { statuses } from '@/datas/responseStatuses'
import { unixTimeStampToDate } from '@/helpers/date'

export default {
  name: 'DateInProgress',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    setOpen: {
      type: Function,
      default: () => {},
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      colorStatus: null,
    }
  },
  mounted() {
    this.colorStatus = {
      info: this.response.status === 0,
      success: this.response.status === 1,
      warning: this.response.status === 2,
      danger: this.response.status === 3,
    }
  },
  methods: {
    getStatus(status) {
      return status >= 0 && statuses[status] ? statuses[status].name : ''
    },
    getStatusFio(status) {
      if (
        status === 0 &&
        statuses[status] &&
        this.response['user-role'] === 'admin'
      ) {
        return `от ${this.shortFio(this.response.user.fio)}`
      }
    },
    getDate(res) {
      return (
        res.request_created_at &&
        this.dateToFormat(
          unixTimeStampToDate(res.request_created_at),
          'respStatusDate',
        )
      )
    },
  },
}
</script>

<style lang="sass">
.bids-list .middle-section .check-list .check-list-person
  .date
    font-size: 15px
    line-height: 14px
    color: #8694A4
    margin: 10px 0
    &.status
      text-decoration: underline
    &.info
      color: #909399
    &.success
      color: #67C23A
    &.warning
      color: #E6A23C
    &.danger
      color: #F56C6C
</style>
